import React, { useEffect, useState, useContext } from 'react';
import { toast } from 'react-toastify';
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import VisibilityIcon from '@mui/icons-material/Visibility';
import { AuthContext } from '../../context/authContext';
import { PopupContext } from "../../context/popupContext";
import { logoutUser, addEmployeeAdmin, getEmployeeAdmins } from '../../utilities/sendRequest';
import { adminRoles, statusOptions } from '../../utilities/selectOptions';
import ModalEmployeeAdmin from '../../components/Admin/modalEmployeeAdmin';

const EmployeeAdmin = () => {
    const { dispatch } = useContext(AuthContext)
    const { popupDispatch } = useContext(PopupContext)
    const [datas, setDatas] = useState([])
    const [showModalDetail, setShowModalDetail] = useState(false)
    const [fetchMore, setFetchMore] = useState(true)
    const [isReady, setIsReady] = useState(false)
    const [fullname, setFullname] = useState("")
    const [nip, setNip] = useState("")
    const [email, setEmail] = useState("")
    const [password, setPassword] = useState("")
    const [cardId, setCardId] = useState("")
    const [adminRole, setAdminRole] = useState("")
    const [status, setStatus] = useState("")
    const [data, setData] = useState([])

    useEffect(() => {
        const isReady = (fullname, nip, email, password, cardId, adminRole, status);
        setIsReady(isReady);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [fullname, nip, email, password, cardId, adminRole, status])

    useEffect(() => {
        fetchEmployeeAdmin()
        setFetchMore(false)

        // eslint-disable-next-line
    }, [fetchMore])

    const fetchEmployeeAdmin = async () => {
        getEmployeeAdmins().then((res) => {
            setDatas(
                res.payload.sort((p1, p2) => {
                    return new Date(p2.createdAt) - new Date(p1.createdAt)
                })
            )
        }).catch((err) => {
            toast.error(err.message, {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 3000
            });

            if (err.response.status === 401) {
                setTimeout(() => {
                    logoutUser(dispatch)
                }, 2500)
            }
        })
    }

    const handleCreate = async (e) => {
        e.preventDefault()

        setIsReady(false)

        const reqData = {
            fullname,
            email,
            password,
            nip,
            id_card: cardId,
            is_active: status,
            is_admin: adminRole
        }

        addEmployeeAdmin(reqData).then((res) => {
            toast.success(res.message, {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 3000
            });
            setFetchMore(true)
            resetForm()
        }).catch((err) => {
            console.log(err);
            
            toast.error(err.response.data.message, {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 3000
            });
        }).finally(() => {
            setIsReady(true)
        })
    }

    const resetForm = () => {
        setFullname("")
        setEmail("")
        setPassword("")
        setNip("")
        setCardId("")
        setAdminRole("")
        setStatus("")
    }

    const handleModal = (row) => {
        setShowModalDetail(true)
        setData(row)
        popupDispatch({ type: "POPUP_START" });
    }

    const columns = [
        { 
            field: 'fullname', 
            headerName: 'Nama',
            width: 150, 
            renderCell: (params) => {
                return (
                    <div className='flex justify-center items-center font-ssp'>
                        {params.row.fullname}
                    </div>
                )
            } 
        },
        { 
            field: 'is_admin', 
            headerName: 'Role',
            width: 100, 
            renderCell: (params) => {
                return (
                    <div className='flex justify-center items-center font-ssp uppercase'>
                        {params.row.is_admin}
                    </div>
                )
            } 
        },
        {
            field: 'status',
            headerName: 'Status',
            width: 150,
            renderCell: (params) => {
                return (
                    <div className="font-ssp">
                        {params.row.is_active
                            ? <span className="px-2 py-1 bg-green-400 rounded-full text-white uppercase">active</span>
                            : <span className="px-2 py-1 bg-red-400 rounded-full text-white uppercase">inactive</span>
                        }
                    </div>
                )
            } 
        },
        {
            field: 'action',
            headerName: 'Action',
            width: 150,
            renderCell: (params) => {
                return (
                    <div className='w-full flex flex-row items-center gap-3'>
                        <VisibilityIcon fontSize='medium' className="text-slate-400 hover:text-slate-500 cursor-pointer" onClick={() => handleModal(params.row)}/>
                    </div>
                )
            }
        },
    ]

    return (
        <>
            {showModalDetail && <ModalEmployeeAdmin data={data} setShowModalDetail={setShowModalDetail} setFetchMore={setFetchMore} />}
            <div className={`min-h-[calc(100vh-4rem)] flex flex-col ${showModalDetail && 'fixed min-w-[calc(100vw-16.666667%)]'} `}>
                {/* header  */}
                <div className="my-5 mb-5 mx-7 md:mx-5 flex flex-col md:flex-row justify-between">
                    <h1 className='font-ssp font-bold text-2xl md:text-3xl'>Employee Admin</h1>
                </div>
                {/* content  */}
                <div className="my-5 mx-7 md:mx-5 flex flex-col lg:flex-row justify-evenly gap-7 md:gap-10">
                    {/* list data */}
                    <div className='w-full h-full lg:w-[50%] flex flex-col gap-3 items-center'>
                        <div className="p-2 w-full bg-white drop-shadow-lg rounded-md flex">
                            <DataGrid
                                autoHeight {...datas}
                                rows={datas}
                                columns={columns}
                                pageSize={10}
                                getRowId={(row) => row.nip}
                                rowsPerPageOptions={[10]}
                                checkboxSelection
                                disableSelectionOnClick
                                components={{ Toolbar: GridToolbar, }}
                            />
                        </div>
                    </div>

                    {/* form store */}
                    <div className="px-2 py-4 w-full h-fit lg:w-[50%] bg-white drop-shadow-lg rounded-md flex flex-col gap-3">
                        <h1 className='font-semibold text-base font-ssp px-3'>Create New Admin</h1>
                        <hr className='px-3'/>
                        <div className=" py-1 w-full h-fit flex">
                            <form onSubmit={handleCreate} className='px-5 w-full flex flex-col justify-between'>
                                {/* name */}
                                <div className="mt-3 mb-6 w-full relative z-0 group">
                                    <input 
                                        value={fullname} 
                                        onChange={(e) => setFullname(e.target.value)} 
                                        type="text" 
                                        name="fullname" 
                                        id="fullname" 
                                        className="block py-2.5 px-2 w-full text-sm text-gray-900 bg-transparent 
                                                    border-0 border-b-2 border-gray-300 appearance-none focus:outline-none focus:ring-0 
                                                    focus:border-blue-600 peer" 
                                        placeholder=" " 
                                        required 
                                    />
                                    <label 
                                        htmlFor="fullname" 
                                        className="absolute top-3 -z-10 text-sm text-gray-500 
                                                    duration-300 transform -translate-y-6 scale-75 origin-[0] peer-focus:left-0 peer-focus:font-medium 
                                                    peer-focus:text-blue-600 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 
                                                    peer-focus:scale-75 peer-focus:-translate-y-6"
                                    >Fullname</label>
                                </div>
                                {/* mail */}
                                <div className="mt-3 mb-6 w-full relative z-0 group">
                                    <input 
                                        value={email} 
                                        onChange={(e) => setEmail(e.target.value)} 
                                        type="mail" 
                                        name="email" 
                                        id="email" 
                                        className="block py-2.5 px-2 w-full text-sm text-gray-900 bg-transparent 
                                                    border-0 border-b-2 border-gray-300 appearance-none focus:outline-none focus:ring-0 
                                                    focus:border-blue-600 peer" 
                                        placeholder=" " 
                                        required 
                                    />
                                    <label 
                                        htmlFor="email" 
                                        className="absolute top-3 -z-10 text-sm text-gray-500 
                                                    duration-300 transform -translate-y-6 scale-75 origin-[0] peer-focus:left-0 peer-focus:font-medium 
                                                    peer-focus:text-blue-600 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 
                                                    peer-focus:scale-75 peer-focus:-translate-y-6"
                                    >Email</label>
                                </div>
                                {/* password */}
                                <div className="mt-3 mb-6 w-full relative z-0 group">
                                    <input 
                                        value={password} 
                                        onChange={(e) => setPassword(e.target.value)} 
                                        type="password" 
                                        name="password" 
                                        id="password" 
                                        autoComplete='password'
                                        className="block py-2.5 px-2 w-full text-sm text-gray-900 bg-transparent 
                                                    border-0 border-b-2 border-gray-300 appearance-none focus:outline-none focus:ring-0 
                                                    focus:border-blue-600 peer" 
                                        placeholder=" " 
                                        required 
                                    />
                                    <label 
                                        htmlFor="password" 
                                        className="absolute top-3 -z-10 text-sm text-gray-500 
                                                    duration-300 transform -translate-y-6 scale-75 origin-[0] peer-focus:left-0 peer-focus:font-medium 
                                                    peer-focus:text-blue-600 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 
                                                    peer-focus:scale-75 peer-focus:-translate-y-6"
                                    >Password</label>
                                </div>
                                {/* nip */}
                                <div className="mt-3 mb-6 w-full relative z-0 group">
                                    <input 
                                        value={nip} 
                                        onChange={(e) => setNip(e.target.value)} 
                                        type="text" 
                                        name="nip" 
                                        id="nip" 
                                        className="block py-2.5 px-2 w-full text-sm text-gray-900 bg-transparent 
                                                    border-0 border-b-2 border-gray-300 appearance-none focus:outline-none focus:ring-0 
                                                    focus:border-blue-600 peer" 
                                        placeholder=" " 
                                        required 
                                    />
                                    <label 
                                        htmlFor="nip" 
                                        className="absolute top-3 -z-10 text-sm text-gray-500 
                                                    duration-300 transform -translate-y-6 scale-75 origin-[0] peer-focus:left-0 peer-focus:font-medium 
                                                    peer-focus:text-blue-600 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 
                                                    peer-focus:scale-75 peer-focus:-translate-y-6"
                                    >NIP</label>
                                </div>
                                {/* id card */}
                                <div className="mt-3 mb-6 w-full relative z-0 group">
                                    <input 
                                        value={cardId} 
                                        onChange={(e) => setCardId(e.target.value)} 
                                        type="text" 
                                        name="cardId" 
                                        id="cardId" 
                                        className="block py-2.5 px-2 w-full text-sm text-gray-900 bg-transparent 
                                                    border-0 border-b-2 border-gray-300 appearance-none focus:outline-none focus:ring-0 
                                                    focus:border-blue-600 peer" 
                                        placeholder=" " 
                                        required 
                                    />
                                    <label 
                                        htmlFor="cardId" 
                                        className="absolute top-3 -z-10 text-sm text-gray-500 
                                                    duration-300 transform -translate-y-6 scale-75 origin-[0] peer-focus:left-0 peer-focus:font-medium 
                                                    peer-focus:text-blue-600 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 
                                                    peer-focus:scale-75 peer-focus:-translate-y-6"
                                    >ID Card</label>
                                </div>
                                {/* roles */}
                                <div className="mt-3 mb-6 w-full relative z-0 group">
                                    <select 
                                        required 
                                        value={adminRole} 
                                        onChange={(e) => setAdminRole(e.target.value)} 
                                        id="adminRole" 
                                        className="block py-2.5 px-2 w-full text-sm text-gray-500 bg-transparent 
                                                    border-0 border-b-2 border-gray-300 appearance-none focus:outline-none focus:ring-0 
                                                    focus:border-blue-600 peer"
                                    >
                                        {adminRoles.map((option) => (
                                            <option key={option.value} value={option.value}>{option.label}</option>
                                        ))}
                                    </select>
                                    <label 
                                        htmlFor="adminRole" 
                                        className="absolute top-3 -z-10 text-sm text-gray-500 
                                                    duration-300 transform -translate-y-6 scale-75 origin-[0] peer-focus:left-0 peer-focus:font-medium 
                                                    peer-focus:text-blue-600 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 
                                                    peer-focus:scale-75 peer-focus:-translate-y-6"
                                    >Roles</label>
                                </div>
                                {/* status */}
                                <div className="mt-3 mb-6 w-full relative z-0 group">
                                    <select 
                                        required 
                                        value={status} 
                                        onChange={(e) => setStatus(e.target.value)} 
                                        id="status" 
                                        className="block py-2.5 px-2 w-full text-sm text-gray-500 bg-transparent 
                                                    border-0 border-b-2 border-gray-300 appearance-none focus:outline-none focus:ring-0 
                                                    focus:border-blue-600 peer"
                                    >
                                        {statusOptions.map((option) => (
                                            <option key={option.value} value={option.value}>{option.label}</option>
                                        ))}
                                    </select>
                                    <label 
                                        htmlFor="status" 
                                        className="absolute top-3 -z-10 text-sm text-gray-500 
                                                    duration-300 transform -translate-y-6 scale-75 origin-[0] peer-focus:left-0 peer-focus:font-medium 
                                                    peer-focus:text-blue-600 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 
                                                    peer-focus:scale-75 peer-focus:-translate-y-6"
                                    >Status</label>
                                </div>
                                {/* button */}
                                <div className="mb-6 w-full relative z-0 flex justify-center gap-5">
                                    <button 
                                        type="submit" disabled={!isReady}
                                        className={`mt-5 px-5 py-2.5 w-fit rounded-lg sm:w-autorounded-lg font-medium text-sm text-center ${isReady ? 'text-white bg-green-400 hover:bg-green-500 cursor-pointer' : 'text-gray-800 bg-gray-300 cursor-wait'}`}
                                    >Create</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default EmployeeAdmin